// extracted by mini-css-extract-plugin
export default {"vote":"vote-vMEdUB","copy":"copy-DPVoZn"};